<template>
  <div class="flex min-h-screen w-full relative bg-muted/30">
    <!-- Mobile Menu Overlay -->
    <div v-if="isMobileMenuOpen" class="fixed inset-0 bg-black/50 z-40 lg:hidden" @click="isMobileMenuOpen = false">
    </div>

    <!-- Mobile Sidebar -->
    <div :class="[
      'fixed top-0 left-0 h-full bg-black border-r border-border text-white z-50 transform transition-transform duration-300 lg:hidden',
      isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
    ]">
      <div class="p-4 w-64 h-full overflow-y-auto">
        <!-- Mobile Header -->
        <div class="flex items-center justify-between mb-8">
          <router-link to="/admin/dashboard" class="flex items-center space-x-2">
            <img class="w-full h-20 bg-white object-cover object-center" :src="logo" alt="">
          </router-link>
          <button @click="isMobileMenuOpen = false"
            class="p-2 hover:bg-muted hover:text-black rounded-md transition-colors">
            <X class="w-5 h-5" />
          </button>
        </div>

        <!-- Mobile Navigation -->
        <nav class="space-y-1">
          <router-link to="/admin/dashboard" active-class="active-class"
            class="flex items-center space-x-3 px-3 py-3 rounded-md hover:bg-muted hover:text-black transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            <span>Dashboard</span>
          </router-link>

          <router-link to="/admin/brands" active-class="active-class"
            class="flex items-center space-x-3 px-3 py-3 rounded-md hover:text-black hover:bg-muted transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
            </svg>
            <span>marques</span>
          </router-link>
          <router-link to="/admin/categorie" active-class="active-class"
            class="flex items-center space-x-3 px-3 py-3 rounded-md hover:text-black hover:bg-muted transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
            <span>Catégories</span>
          </router-link>
          <router-link to="/admin/fournisseur" active-class="active-class"
            class="flex items-center space-x-3 px-3 py-3 rounded-md hover:text-black hover:bg-muted transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
            <span>fournisseurs</span>
          </router-link>
          <router-link active-class="active-class" to="/admin/produits"
            class="flex items-center space-x-3 px-3 py-3 hover:text-black rounded-md hover:bg-muted transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
            </svg>
            <span>produits</span>
          </router-link>

          <router-link to="/admin/articles" active-class="active-class"
            class="flex items-center space-x-3 px-3 py-3 rounded-md hover:text-black hover:bg-muted transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
            </svg>
            <span>articles</span>
          </router-link>



          <router-link to="/admin/commandes" active-class="active-class"
            class="flex items-center space-x-3 px-3 py-3 rounded-md hover:text-black hover:bg-muted transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <span>Commandes</span>
          </router-link>

          <router-link to="/admin/users" active-class="active-class"
            class="flex items-center space-x-3 px-3 py-3 rounded-md hover:text-black hover:bg-muted transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
            </svg>
            <span>Utilisateurs</span>
          </router-link>

          <!-- Team & fournisseur Links -->
          <!-- <router-link 
              to="/admin/team" 
              active-class="active-class" 
              class="flex items-center space-x-3 px-3 py-3 rounded-md hover:text-black hover:bg-muted transition-colors"
              @click="isMobileMenuOpen = false"
            >
              <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"/>
              </svg>
              <span>Équipe</span>
            </router-link> -->


        </nav>

        <!-- Mobile User Info -->
        <div class="mt-8 pt-8 border-t border-border">
          <div class="flex items-center space-x-3 px-3 py-2">
            <div class="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
              <User class="w-4 h-4 text-primary" />
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium truncate">Admin</p>
              <p class="text-xs text-muted-foreground truncate">Administrateur</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop Sidebar -->
    <div class="w-56 bg-black border-r border-border text-white sticky top-0 h-screen flex-shrink-0 hidden lg:block">
      <img class="w-full h-20 object-cover bg-white object-center" :src="logo" alt="">
      <div class="p-6">
        <h2 class="text-xl font-bold mb-8">Administration</h2>
        <nav class="space-y-1">
          <router-link to="/admin/dashboard" active-class="active-class"
            class="flex items-center space-x-3 px-3 py-3 rounded-md hover:bg-muted hover:text-black transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            <span>Dashboard</span>
          </router-link>

          <router-link to="/admin/brands" active-class="active-class"
            class="flex items-center space-x-3 px-3 py-3 rounded-md hover:text-black hover:bg-muted transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
            </svg>
            <span>marques</span>
          </router-link>
          <router-link to="/admin/categorie" active-class="active-class"
            class="flex items-center space-x-3 px-3 py-3 rounded-md hover:text-black hover:bg-muted transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
            <span>Catégories</span>
          </router-link>
          <router-link to="/admin/fournisseur" active-class="active-class"
            class="flex items-center space-x-3 px-3 py-3 rounded-md hover:text-black hover:bg-muted transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
            <span>fournisseurs</span>
          </router-link>
          <router-link active-class="active-class" to="/admin/produits"
            class="flex items-center space-x-3 px-3 py-3 hover:text-black rounded-md hover:bg-muted transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
            </svg>
            <span>produits</span>
          </router-link>

          <router-link to="/admin/articles" active-class="active-class"
            class="flex items-center space-x-3 px-3 py-3 rounded-md hover:text-black hover:bg-muted transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
            </svg>
            <span>articles</span>
          </router-link>



          <router-link to="/admin/commandes" active-class="active-class"
            class="flex items-center space-x-3 px-3 py-3 rounded-md hover:text-black hover:bg-muted transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <span>Commandes</span>
          </router-link>

          <router-link to="/admin/users" active-class="active-class"
            class="flex items-center space-x-3 px-3 py-3 rounded-md hover:text-black hover:bg-muted transition-colors"
            @click="isMobileMenuOpen = false">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
            </svg>
            <span>Utilisateurs</span>
          </router-link>

          <!-- Team & fournisseur Links -->
          <!-- <router-link 
              to="/admin/team" 
              active-class="active-class" 
              class="flex items-center space-x-3 px-3 py-3 rounded-md hover:text-black hover:bg-muted transition-colors"
              @click="isMobileMenuOpen = false"
            >
              <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"/>
              </svg>
              <span>Équipe</span>
            </router-link> -->


        </nav>

        <!-- Desktop User Info -->
        <div class="mt-8 pt-8 border-t border-border">
          <div class="flex items-center space-x-3 px-3 py-2">
            <div class="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
              <User class="w-4 h-4 text-primary" />
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium truncate">Admin</p>
              <p class="text-xs text-muted-foreground truncate">Administrateur</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="flex-1 flex flex-col min-h-screen">
      <!-- Mobile Header -->
      <header class="lg:hidden md:hidden sticky top-0 z-30 bg-white border-b border-border">
        <div class="flex items-center justify-between px-4 py-3">
          <!-- Hamburger Menu Button -->
          <button @click="isMobileMenuOpen = true" class="p-2 hover:bg-secondary rounded-md transition-colors">
            <Menu class="w-6 h-6 text-foreground" />
          </button>

          <!-- Logo/Title -->
          <div class="flex-1 text-center">
            <h1 class="text-lg font-semibold text-foreground">Administration</h1>
          </div>

          <!-- User Menu (Mobile) -->
          <div class="relative flex items-center gap-2">

            <User class="w-6 h-6 text-foreground" /><button @click="logout"
              class="w-full text-left px-4 py-2 text-sm text-foreground  rounded-md bg-red-200/50 hover:bg-secondary transition-colors">
              Déconnexion
            </button>



          </div>
        </div>
      </header>

      <!-- Desktop Header -->
      <header class="hidden lg:block md:block sticky top-0 z-30 bg-white border-b border-border">
        <div class="flex items-center justify-between px-6 py-4">
          <!-- Breadcrumb -->
          <div class="flex items-center space-x-2">
            <h1 class="text-xl font-semibold text-foreground">Tableau de bord</h1>
          </div>

          <!-- User Menu (Desktop) -->
          <div class="relative">
            <button @click="isUserMenuOpen = !isUserMenuOpen"
              class="flex items-center space-x-2 px-4 py-2 hover:bg-secondary rounded-md transition-colors">
              <div class="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                <User class="w-4 h-4 text-primary" />
              </div>
              <button @click="logout"
                class="w-full text-left px-4 py-2 text-sm text-foreground  rounded-md bg-red-200/50 hover:bg-secondary transition-colors">
                Déconnexion
              </button>
              <!-- <ChevronDown class="w-4 h-4 text-muted-foreground" /> -->
            </button>



          </div>
        </div>
      </header>

      <!-- Main Content Area -->
      <main class="flex-1 p-4 lg:p-6 overflow-auto">
        <!-- Notification -->
        <div v-if="notifi" :class="[
          'fixed top-4 right-4 text-white rounded-md p-4 shadow-lg z-50 transition-all duration-300',
          notif.type === 'success' ? 'bg-green-500' : 'bg-red-500'
        ]">
          <div class="flex items-start space-x-3">
            <div class="flex-shrink-0">
              <component :is="notif.type === 'success' ? CheckCircle : AlertCircle" class="w-5 h-5" />
            </div>
            <div class="flex-1 min-w-0">
              <p class="font-bold text-sm">{{ notif.title }}</p>
              <p class="text-sm opacity-90 mt-1">{{ notif.message }}</p>
            </div>
            <button @click="notifi = false" class="flex-shrink-0 ml-3 hover:opacity-80 transition-opacity">
              <X class="w-4 h-4" />
            </button>
          </div>
        </div>

        <!-- Page Content -->
        <router-view @notify="notify" name="tree" />
      </main>

      <!-- Mobile Footer -->
      <footer class="lg:hidden bg-white border-t border-border py-3 px-4">
        <div class="flex items-center justify-between">
          <p class="text-xs text-muted-foreground">
            © {{ new Date().getFullYear() }} cassuss e-commerce
          </p>
          <p class="text-xs text-muted-foreground">
            Version 1.0.0
          </p>
        </div>
      </footer>

      <!-- Desktop Footer -->
      <footer class="hidden lg:block bg-white border-t border-border py-4 px-6">
        <div class="flex items-center justify-between">
          <p class="text-sm text-muted-foreground">
            © {{ new Date().getFullYear() }} cassuss e-commerce - Tous droits réservés
          </p>
          <div class="flex items-center space-x-4">
            <p class="text-sm text-muted-foreground">
              Version 1.0.0
            </p>
            <a href="/admin/support" class="text-sm text-primary hover:underline">
              Support
            </a>
            <a href="/admin/help" class="text-sm text-primary hover:underline">
              Aide
            </a>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { Menu, X, User, ChevronDown, CheckCircle, AlertCircle } from 'lucide-vue-next'

export default {
  name: "AdminLayout",

  components: {
    Menu,
    X,
    User,
    ChevronDown,
    CheckCircle,
    AlertCircle
  },

  data() {
    return {
      logo: require('@/assets/logo.png'),
      notif: {
        title: '',
        message: '',
        type: ''
      },
      notifi: false,
      isMobileMenuOpen: false,
      isUserMenuOpen: false,
      isMobile: false,
      lastScrollY: 0,
      headerVisible: true
    }
  },

  methods: {
    menuset() {
      this.isUserMenuOpen = !this.isUserMenuOpen
    },
    notify(notif) {
      this.notif = notif
      this.notifi = true
      setTimeout(() => {
        this.notifi = false
      }, 5000)
    },

    logout() {
      this.$store.dispatch('logout')
      this.isUserMenuOpen = false
    },

    checkMobile() {
      this.isMobile = window.innerWidth < 1024
    },

    handleScroll() {
      if (this.isMobile) {
        const currentScrollY = window.scrollY
        if (currentScrollY > this.lastScrollY && currentScrollY > 50) {
          this.headerVisible = false
        } else {
          this.headerVisible = true
        }
        this.lastScrollY = currentScrollY
      }
    },

    closeMenus() {
      this.isMobileMenuOpen = false
      this.isUserMenuOpen = false
    },

    handleClickOutside(event) {
      if (!event.target.closest('.user-menu-button')) {
        this.isUserMenuOpen = false
      }
    }
  },

  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    window.addEventListener('scroll', this.handleScroll)
    document.addEventListener('click', this.handleClickOutside)

    // Fermer les menus au changement de route
    this.$router.afterEach(() => {
      this.closeMenus()
    })
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile)
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style scoped>
/* Animation pour la notification */
.anim {
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.active-class {
  background: white;
  color: black;
  font-weight: 600;
}

/* Animation pour le menu mobile */
.fixed {
  position: fixed;
}

.transform {
  transform: translate3d(0, 0, 0);
  transition: transform 0.3s ease;
}

.-translate-x-full {
  transform: translateX(-100%);
}

.translate-x-0 {
  transform: translateX(0);
}

/* Styles pour le header mobile */
header {
  transition: transform 0.3s ease;
}


/* Styles pour les liens */
a.router-link-active {
  background-color: white;
  color: black;
  border-radius: 0.375rem;
}

a:hover {
  background-color: hsl(var(--muted));
  color: black;
}

/* Styles pour les dropdowns */
.z-50 {
  z-index: 50;
}

.shadow-lg {
  box-shadow: 0 10px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
}

/* Styles responsive */
@media (max-width: 640px) {
  .container-custom {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media (min-width: 641px) and (max-width: 768px) {
  .container-custom {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .container-custom {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@media (min-width: 1025px) {
  .container-custom {
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

/* Scrollbar styling */
.overflow-y-auto {
  scrollbar-width: thin;
  scrollbar-color: hsl(var(--border)) transparent;
}

.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  background: transparent;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: hsl(var(--border));
  border-radius: 20px;
}

/* Loading states */
.loading {
  opacity: 0.6;
  pointer-events: none;
}

/* Focus states for accessibility */
button:focus-visible,
a:focus-visible {
  outline: 2px solid hsl(var(--primary));
  outline-offset: 2px;
}

/* Print styles */
@media print {
  .no-print {
    display: none;
  }
}
</style>
